module.exports = __webpack_public_path__ + "static/clearco-logo-3fc86be05428b9196df4b8a6fb0537ad.png";